import { CONNECTORS_UI_PATH } from '#pplx/frontend/apps/ask/connectors/consts/connectors.js';
import { usePluginEntitiesEnabled } from '#pplx/frontend/apps/ask/connectors/hooks/usePluginsNavigationHrefs.js';
export function useManageConnectorsHref() {
    return usePluginEntitiesEnabled().enabled
        ? '/computer/plugins?tab=installed'
        : CONNECTORS_UI_PATH;
}
//# sourceMappingURL=useManageConnectorsHref.js.map